// WS-2 Wave 3 cutover flag (docs/plans/AUTH_SESSION_HARDENING.md).
//
// When enabled, the SPA runs in COOKIE-ONLY auth mode:
//   - it does NOT send the `Authorization: Bearer` header (the HttpOnly
//     `vharta_local_session` / `vharta_session` cookie is the sole HTTP auth,
//     carried automatically via credentials:'include'), and
//   - it does NOT persist the access token to localStorage (in-memory only),
//     removing the XSS "read localStorage and exfiltrate the token" vector.
//
// Default OFF: every gate is written so that a false result reproduces the exact
// pre-flag behaviour (Bearer sent, token persisted). Precedence mirrors the
// existing useUnifiedCanvasFlag pattern: build-time env override →
// per-browser localStorage override → default false.
//
// X.13: the localStorage override now goes through vhartaFlags' getVhartaFlag
// (same helper useUnifiedCanvasFlag.ts uses) rather than a raw
// localStorage.getItem — semantics are unchanged (env override still wins,
// 'true'/'false' string checks still gate the same way, default is still
// false), but the stored value now expires after 14 days like every other
// vharta.* client override and is visible to the dev-mode overrides panel.
// A cookie-auth cutover is meant to be a deliberate, soaked rollout (see the
// DevMode caveat below) — if a real deployment needs this flag to outlive 14
// days, set it via the build-time VITE_COOKIE_AUTH env var instead of a
// localStorage override.
//
// IMPORTANT: cookie-only auth CANNOT function on a DevMode cluster (dev-india):
// dev tokens are not JWTs and the gateway resolves DevMode identity from the
// Authorization header, never the cookie. So this flag only does something
// useful on a real (non-dev) deployment, and must be flipped there, coordinated
// with a soak. See AUTH_SESSION_HARDENING.md WS-2 cutover sequencing.
import { getVhartaFlag } from './vhartaFlags'

const COOKIE_AUTH_FLAG_KEY = 'vharta.cookie_auth'

export function cookieAuthEnabled(): boolean {
  const env = import.meta.env.VITE_COOKIE_AUTH
  if (env === 'true' || env === '1') return true
  if (env === 'false' || env === '0') return false
  const override = getVhartaFlag(COOKIE_AUTH_FLAG_KEY)
  if (override === 'true') return true
  if (override === 'false') return false
  return false
}
